// extracted by mini-css-extract-plugin
module.exports = {"compareMain":"purify_page__compareMain--1zVxI","hide":"purify_page__hide--DuxDC"};